export const GetHeatmapSummary = 'EmploymentEquity/Deviations/HeatmapSummary';
export const GetPlanSummary = 'EmploymentEquity/Deviations/PlanSummary';
export const GetPlanSummaryMovementIndividuals = 'EmploymentEquity/Deviations/PlanSummaryMovementIndividuals';
export const SearchJustifications = 'EmploymentEquity/Deviations/Search';
export const GetDeviationById = (scorecardId: string, id: number) => `EmploymentEquity/Deviations/${scorecardId}/${id}`;
export const CreateDeviation = 'EmploymentEquity/Deviations';
export const UpdateDeviation = 'EmploymentEquity/Deviations';
export const DeleteDeviationById = (scorecardId: string, id: number) => `EmploymentEquity/Deviations/${scorecardId}/${id}`;
export const GetRecruitmentPromotionMovements = 'EmploymentEquity/Deviations/RecruitmentPromotionMovements';
export const GetJustificationSummary = 'EmploymentEquity/Deviations/JustificationSummary';
